// src/api/axios.js
// API 총괄
import axios from 'axios';


function getCookie(name) {
  const cookieValue = document.cookie
    .split('; ')
    .find(row => row.startsWith(name + '='))
    ?.split('=')[1];
  return cookieValue;
}

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE,
  withCredentials: true,

});



api.interceptors.request.use(config => {
  const token = getCookie('csrftoken');
  if (token) config.headers['X-CSRFToken'] = token;
  return config;
});

export default api;